<template>
  <main-template ref="main_template">
    <template v-slot:main>

      <Carousel v-bind="CarouselConfig">
        <Slide v-for="slide in CarouselData" :key="slide">
          <a class="slide" :href="slide.link"><img class="slide_image" :src="slide.image"></a>
        </Slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>

      <div class="main_tabs">
        <div class="tab_item" :class="[{active: activeTab == 'main'}]" @click="changeTab('main')">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M1.5 10.3261C1.5 9.47215 1.5 9.04518 1.60929 8.65144C1.70611 8.30264 1.86525 7.97424 2.07902 7.68212C2.32034 7.35236 2.65546 7.08779 3.32571 6.55865L8.02571 2.84812C9.08828 2.00925 9.61957 1.58981 10.2076 1.42878C10.7263 1.28671 11.2737 1.28671 11.7924 1.42878C12.3804 1.58981 12.9117 2.00925 13.9743 2.84813L18.6743 6.55865C19.3445 7.08779 19.6797 7.35236 19.921 7.68212C20.1348 7.97424 20.2939 8.30264 20.3907 8.65144C20.5 9.04518 20.5 9.47215 20.5 10.3261V15.7C20.5 17.3802 20.5 18.2202 20.173 18.862C19.8854 19.4265 19.4265 19.8854 18.862 20.173C18.2202 20.5 17.3802 20.5 15.7 20.5H15.6C15.0399 20.5 14.7599 20.5 14.546 20.391C14.3578 20.2951 14.2049 20.1422 14.109 19.954C14 19.7401 14 19.4601 14 18.9V16.1C14 15.5399 14 15.2599 13.891 15.046C13.7951 14.8578 13.6422 14.7049 13.454 14.609C13.2401 14.5 12.9601 14.5 12.4 14.5H11H9.6C9.03995 14.5 8.75992 14.5 8.54601 14.609C8.35785 14.7049 8.20487 14.8578 8.10899 15.046C8 15.2599 8 15.5399 8 16.1V18.9C8 19.4601 8 19.7401 7.89101 19.954C7.79513 20.1422 7.64215 20.2951 7.45399 20.391C7.24008 20.5 6.96005 20.5 6.4 20.5H6.3C4.61984 20.5 3.77976 20.5 3.13803 20.173C2.57354 19.8854 2.1146 19.4265 1.82698 18.862C1.5 18.2202 1.5 17.3802 1.5 15.7L1.5 10.3261Z" stroke="#656565" stroke-width="1.5"/>
          </svg>
          <span>Главная</span>
        </div>
        <div class="tab_item" :class="[{active: activeTab == 'calendar'}]" @click="changeTab('calendar')">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M17 1V3M5 1V3" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.9955 12H11.0045M10.9955 16H11.0045M14.991 12H15M7 12H7.00897M7 16H7.00897" stroke="#656565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.5 7H19.5" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.5 11.2432C1.5 6.88594 1.5 4.70728 2.75212 3.35364C4.00424 2 6.01949 2 10.05 2H11.95C15.9805 2 17.9958 2 19.2479 3.35364C20.5 4.70728 20.5 6.88594 20.5 11.2432V11.7568C20.5 16.1141 20.5 18.2927 19.2479 19.6464C17.9958 21 15.9805 21 11.95 21H10.05C6.01949 21 4.00424 21 2.75212 19.6464C1.5 18.2927 1.5 16.1141 1.5 11.7568V11.2432Z" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 7H20" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Календарь</span>
        </div>
        <div class="tab_item" :class="[{active: activeTab == 'settings'}]" @click="changeTab('settings')">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M20.3175 6.14139L19.8239 5.28479C19.4506 4.63696 19.264 4.31305 18.9464 4.18388C18.6288 4.05472 18.2696 4.15664 17.5513 4.36048L16.3311 4.70418C15.8725 4.80994 15.3913 4.74994 14.9726 4.53479L14.6357 4.34042C14.2766 4.11043 14.0004 3.77133 13.8475 3.37274L13.5136 2.37536C13.294 1.71534 13.1842 1.38533 12.9228 1.19657C12.6615 1.00781 12.3143 1.00781 11.6199 1.00781H10.5051C9.81078 1.00781 9.4636 1.00781 9.20223 1.19657C8.94085 1.38533 8.83106 1.71534 8.61149 2.37536L8.27753 3.37274C8.12465 3.77133 7.84845 4.11043 7.48937 4.34042L7.15249 4.53479C6.73374 4.74994 6.25259 4.80994 5.79398 4.70418L4.57375 4.36048C3.85541 4.15664 3.49625 4.05472 3.17867 4.18388C2.86109 4.31305 2.67445 4.63696 2.30115 5.28479L1.80757 6.14139C1.45766 6.74864 1.2827 7.05227 1.31666 7.37549C1.35061 7.69871 1.58483 7.95918 2.05326 8.48012L3.0843 9.63282C3.3363 9.95185 3.51521 10.5078 3.51521 11.0077C3.51521 11.5078 3.33636 12.0636 3.08433 12.3827L2.05326 13.5354C1.58483 14.0564 1.35062 14.3168 1.31666 14.6401C1.2827 14.9633 1.45766 15.2669 1.80757 15.8741L2.30114 16.7307C2.67443 17.3785 2.86109 17.7025 3.17867 17.8316C3.49625 17.9608 3.85542 17.8589 4.57377 17.655L5.79394 17.3113C6.25263 17.2055 6.73387 17.2656 7.15267 17.4808L7.4895 17.6752C7.84851 17.9052 8.12464 18.2442 8.2775 18.6428L8.61149 19.6403C8.83106 20.3003 8.94085 20.6303 9.20223 20.8191C9.4636 21.0078 9.81078 21.0078 10.5051 21.0078H11.6199C12.3143 21.0078 12.6615 21.0078 12.9228 20.8191C13.1842 20.6303 13.294 20.3003 13.5136 19.6403L13.8476 18.6428C14.0004 18.2442 14.2765 17.9052 14.6356 17.6752L14.9724 17.4808C15.3912 17.2656 15.8724 17.2055 16.3311 17.3113L17.5513 17.655C18.2696 17.8589 18.6288 17.9608 18.9464 17.8316C19.264 17.7025 19.4506 17.3785 19.8239 16.7307L20.3175 15.8741C20.6674 15.2669 20.8423 14.9633 20.8084 14.6401C20.7744 14.3168 20.5402 14.0564 20.0718 13.5354L19.0407 12.3827C18.7887 12.0636 18.6098 11.5078 18.6098 11.0077C18.6098 10.5078 18.7888 9.95185 19.0407 9.63282L20.0718 8.48012C20.5402 7.95918 20.7744 7.69871 20.8084 7.37549C20.8423 7.05227 20.6674 6.74864 20.3175 6.14139Z" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M14.5195 11C14.5195 12.933 12.9525 14.5 11.0195 14.5C9.08653 14.5 7.51953 12.933 7.51953 11C7.51953 9.067 9.08653 7.5 11.0195 7.5C12.9525 7.5 14.5195 9.067 14.5195 11Z" stroke="#656565" stroke-width="1.5"/>
          </svg>
          <span class="mh">Настройки</span>
        </div>
      </div>

      <main-tab v-if="activeTab == 'main'" @basket_changed="basket_changed_handler()"></main-tab>
      <calendar-tab v-if="activeTab == 'calendar'"></calendar-tab>
      <settings-tab v-if="activeTab == 'settings'"></settings-tab>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import MainTab from "@/components/main/tabs/MainTab.vue";
import CalendarTab from "@/components/main/tabs/CalendarTab.vue";
import SettingsTab from "@/components/main/tabs/SettingsTab.vue";

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import axios from "axios";

export default {
  name: 'MainView',
  components: {
    MainTemplate,
    MainTab,
    CalendarTab,
    SettingsTab,

    Carousel, Slide, Pagination, Navigation,
  },
  data() {
    return{
      activeTab: "main",

      CarouselConfig : {
        itemsToShow: 1
      },
      CarouselData : []
    }
  },
  methods : {
    changeTab: function(tab) {
      this.$router.push(
          {
            name:'main',
            params: {tab: tab}
          }
      )
    },
    loadData: async function() {
      let res = await axios.get(window.api_url + "main/banners");
      this.CarouselData = res.data.data;
    },
    basket_changed_handler: function() {
      this.$refs.main_template.refreshHeader();
    },
    slideToHash: async function() {
      if(this.$route.hash != null && this.$route.hash != "") {
        await new Promise(r => setTimeout(r, 100));
        document.querySelector(this.$route.hash).scrollIntoView();
      }
    }
  },
  mounted : function() {
    this.loadData();

    this.activeTab = this.$route.params.tab;

    this.slideToHash();
  },
  watch: {
    '$route.query'() {
      this.activeTab = this.$route.params.tab;

      this.slideToHash();
    }
  }
}
</script>

<style>
.carousel {
  margin: -16px 0px;
}

.carousel__next, .carousel__prev {
  border-radius: 100px;
  background: #fff;
  margin: 0px;
}

.carousel__next {
  right: 20px;
  left: unset;
  position: absolute;
  bottom: 19px;
  top: unset;
}

.carousel__prev {
  right: 60px;
  left: unset;
  position: absolute;
  bottom: 19px;
  top: unset;
}

.carousel__pagination {
  position: absolute;
  bottom: 40px;
  right: 110px;
  display: flex;
  align-items: center;
}

.carousel__pagination-button {
  padding: 3px;
}

.carousel__pagination-button::after {
  width: 6px;
  height: 6px;
  border-radius: 100px;
  background: #fff;
  padding: 0px;
}

.carousel__pagination-button--active {
  border-radius: 100px;
  border: 1px solid #1B78BC;
}

.carousel__pagination-button--active::after {
  background: #1B78BC;
}

@media (hover: hover) {
  .carousel__pagination-button:hover::after{
    width: 6px;
    height: 6px;
    border-radius: 100px;
    background: #fff;
  }
}

</style>

<style scoped>

/*slider*/

a.slide {
  width: 100%;
  display: block;
}

.slide_image {
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  display: block;
  object-fit: cover;
}

/*tabs*/
.main_tabs {
  background: var(--White, #FFFFFF);
  border-radius: 0px 0px 8px 8px;
  padding: 5px;
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
}

.main_tabs .tab_item {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 13px 24px;
  border-radius: 3px;
  cursor: pointer;
}

.main_tabs .tab_item:hover {
  background: var(--BG, #F8F8F8);
}

.main_tabs .tab_item:hover span{
  /*color: var(--Blue, #1B78BC);*/
}

.main_tabs .tab_item:hover svg path{
  /*stroke: var(--Blue, #1B78BC);*/
}

.main_tabs .tab_item.active {
  background: rgba(27, 120, 188, 0.10);
}

.main_tabs .tab_item.active span{
  color: var(--Blue, #1B78BC);
}

.main_tabs .tab_item.active svg path{
  stroke: var(--Blue, #1B78BC);
}

.main_tabs .tab_item svg{
  width: 24px;
  height: 24px;
}

.main_tabs .tab_item span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .main_tabs .tab_item {
    padding: 9px 15px;
  }
  .main_tabs .tab_item span {
    font-size: 14px;
  }
  .main_tabs .tab_item span.mh {
    display: none;
  }
}
</style>
